import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {UserService} from '../../../services/user/user.service';
import {FeatureAccessService} from '../../../services/feature-access/feature-access.service';
import {ProductAnnouncement} from '../../../config/feature-presentations';
import {ColorType} from '../fe-icon/fe-icon.component';

/**
 * Encart léger annonçant une nouveauté produit (voir PRODUCT_ANNOUNCEMENTS).
 * Un clic ouvre la modale de présentation, la croix masque définitivement l'annonce.
 */
@Component({
  selector: 'fe-announcement-card',
  templateUrl: './fe-announcement-card.component.html',
  styleUrls: ['./fe-announcement-card.component.scss']
})
export class FeAnnouncementCardComponent implements OnInit, OnDestroy {

  // Mode colonne réduite : simple pastille
  @Input() compact: boolean = false;

  protected announcement: ProductAnnouncement | undefined;
  protected readonly ColorType = ColorType;
  private sessionSubscription: Subscription;

  constructor(private userService: UserService,
              private featureAccessService: FeatureAccessService) {
  }

  public ngOnInit(): void {
    this.sessionSubscription = this.userService.getSessionDatas().subscribe(() => {
      this.announcement = this.featureAccessService.getActiveAnnouncement();
    });
  }

  public ngOnDestroy(): void {
    this.sessionSubscription?.unsubscribe();
  }

  protected open(): void {
    this.featureAccessService.openAnnouncement(this.announcement);
  }

  protected dismiss($event: Event): void {
    $event.stopPropagation();
    this.featureAccessService.dismissAnnouncement(this.announcement.id);
    this.announcement = undefined;
  }
}
